import React from 'react';
import { Modal } from 'react-bootstrap';

export default function PromptConfirmation(props) {
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{
                borderRadius: '.3rem',
                overflow: 'hidden',
                backgroundColor: 'transparent',
                boxShadow: 'none',
                border: 'none',
            }}
        >
            <Modal.Body
                style={{
                    padding: 0,
                    position: 'relative',
                    borderRadius: '.3rem',
                    overflow: 'hidden',
                }}
            >
                <button
                    type="button"
                    className="btn-close position-absolute"
                    style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        backgroundColor: 'white',
                        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                        border: 'none',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        color: 'black',
                        fontSize: '20px',
                        fontWeight: 'bold',
                        top: '10px',
                        right: '10px',
                        zIndex: '1',
                    }}
                    onClick={props.onHide}
                    aria-label="Close"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
                <a href="https://instapol.my/" target="_blank" rel="noopener noreferrer">
                    <img
                        src={props.imageSrc}
                        alt="Full-Sized Image"
                        className="img-fluid modal-image"
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            borderRadius: '.3rem',
                        }}
                    />
                </a>
            </Modal.Body>
        </Modal>
    );
}
